var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"mb-0 section"},[_c('h2',{staticClass:"section-text"},[_vm._v(_vm._s(_vm.section))])]),_c('v-row',{ref:"postContent",staticClass:"mt-0 post-content"},[_c(_vm.PostComponentMap[_vm.post.type],{tag:"component",attrs:{"post":_vm.post}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }